// extracted by mini-css-extract-plugin
export default {"testNameWrapper":"TestName_testNameWrapper__Pkccj","testName":"TestName_testName__5X9jD","iconDesktop":"TestName_iconDesktop__BOHIp"};